<ng-container *ngIf="!maintence">

    <router-outlet></router-outlet>

    <app-toast></app-toast>

    <button *ngIf="authService.user != undefined && debugForm"
        class="button-logoff" (click)="logoff()">
        <svg-icon src="assets/images/icon-logout.svg"></svg-icon>
    </button>
</ng-container>

<ng-container *ngIf="maintence">
    <app-maintenance></app-maintenance>
</ng-container>